(function () {
  'use strict';

  angular
    .module('productivity-report', [
      'ui.router',
      'ui.bootstrap',
      'blockUI',
      'angularMoment',
      'restangular',
      'httpServiceV3gModule',
      'ConstantVfiltroModule',
      'ServiceVfiltroModule',
      'FactoryVfiltroModule',
      'ObjetosVfiltroModule',
      'safetyModule',
      'ngSanitize'
    ]);
}());
